export default {
  title: 'Composição de Microaudiência (%)',
  infoDialog: 'Selecionar períodos para comparar a contribuição ao KPI das 5 principais microaudiências demográficas',
  selectWave: 'Selecionar Período',
  projectedWave: 'Período Projetado'
}
